module.exports = __webpack_public_path__ + "img/p1.60528942.png";